import { render, staticRenderFns } from "./friendlink.vue?vue&type=template&id=d645c282&scoped=true&"
import script from "./friendlink.vue?vue&type=script&lang=js&"
export * from "./friendlink.vue?vue&type=script&lang=js&"
import style0 from "./friendlink.vue?vue&type=style&index=0&id=d645c282&scoped=%20scoped&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d645c282",
  null
  
)

export default component.exports